/* eslint-disable @typescript-eslint/no-explicit-any */
import { Paragraph } from '@treams/treams-ui';
import * as graphql from 'generated/graphql';
import { useTranslation } from 'react-i18next';
import { Flex, Box } from 'reflexbox';
import { valueFromMetric } from './AnalyticsMetric';
import { TrafficLight } from './TrafficLight';

export function displayFloat(value: number) {
	return (Math.round(value * 10) / 10) % 1 === 0 ? value.toFixed(0) : value.toFixed(1);
}

export function displayMetric(
	metric:
		| graphql.AnalyticsIntegerMetric
		| graphql.AnalyticsFloatMetric
		| graphql.AnalyticsPercentageMetric
		| graphql.AnalyticsFractionMetric
		| graphql.AnalyticsConversationTemplateMetric,
	extract: (metric: any) => number | undefined,
) {
	const value = extract(metric);

	switch (metric.__typename) {
		case 'AnalyticsPercentageMetric':
			return value ? `${displayFloat(value * 100)}%` : '—';
		case 'AnalyticsIntegerMetric':
			return value;
		case 'AnalyticsFloatMetric':
			return value ? displayFloat(value) : '—';
		case 'AnalyticsFractionMetric':
		case 'AnalyticsConversationTemplateMetric':
			return `${value} / ${metric.total}`;
	}
}

export function AnalyticsNumberMetric(props: {
	metricGroupID: string;
	metric:
		| graphql.AnalyticsIntegerMetric
		| graphql.AnalyticsFloatMetric
		| graphql.AnalyticsPercentageMetric
		| graphql.AnalyticsFractionMetric
		| (graphql.AnalyticsConversationTemplateMetric & { id: string; threshold: number });
	totalUsers: number;
	details?: string;
	subtitle?: string;
}) {
	const { t } = useTranslation();

	return (
		<Box py={1}>
			<Flex alignItems="center" justifyContent="space-between">
				<Box>
					<Paragraph>
						<strong>{displayMetric(props.metric, valueFromMetric)}</strong>{' '}
						{t(`analytics.metrics.${props.metric.id}`, {
							details: props.details,
						})}
					</Paragraph>
					{props.subtitle && (
						<Paragraph mt={-1}>
							<small>{props.subtitle}</small>
						</Paragraph>
					)}
				</Box>
				<TrafficLight
					value={valueFromMetric(props.metric)}
					totalUsers={
						props.metric.__typename === 'AnalyticsIntegerMetric'
							? props.totalUsers
							: props.metric.__typename === 'AnalyticsFractionMetric' ||
							  props.metric.__typename === 'AnalyticsConversationTemplateMetric'
							? props.metric.total
							: undefined
					}
					threshold={props.metric.threshold}
				/>
			</Flex>
		</Box>
	);
}
